var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.90e50c6b1d0fb4e6e5ed3c19731ffa3a.svg#h';
                    var viewUrl = 'sprites.90e50c6b1d0fb4e6e5ed3c19731ffa3a.svg#view-h';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 12 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };